import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/20_card_back_floral_print/20_card_back_floral_print"
 * Contains 1 texture(s)
 */
export class CardsBacks20CardBackFloralPrintAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/20_card_back_floral_print/20_card_back_floral_print';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '20_floral_print.png'
    ] as const;
}
